import { render, staticRenderFns } from "./WebcamTemplate.vue?vue&type=template&id=4620df43&scoped=true"
import script from "./WebcamTemplate.vue.ts?vue&type=script&lang=ts&external"
export * from "./WebcamTemplate.vue.ts?vue&type=script&lang=ts&external"
import style0 from "./WebcamTemplate.vue?vue&type=style&index=0&id=4620df43&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4620df43",
  null
  
)

export default component.exports